// src/utils/TenantRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards a route so only authenticated users with tenant access can access it.
 *
 * Redirects:
 *   unauthenticated       → /login
 *   authenticated non-tenant access → /dashboard
 */
export default function TenantRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-gray-200 dark:border-gray-800 border-t-violet-500 rounded-full animate-spin" />
          <p className="text-sm text-gray-500">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const hasTenantAccess =
    user?.hasTenantAccess === true || Boolean(user?.tenantId);

  if (!hasTenantAccess) return <Navigate to="/dashboard" replace />;

  return children;
}